@if (isFacelift) {
    <iui-modal-header>{{ 'Rx.Export' | translate }}</iui-modal-header>
    <iui-modal-content [gapMultiplier]="2">
        <form class="form-horizontal">
            <iui-select id="exportType-options" name="exportType" [label]="'Rx.ExportType' | translate"
                [options]="exportTypeOptions" [getOptionName]="getOptionName" [compareWith]="compareWith"
                [ngModel]="selectedExportTypeOption" (ngModelChange)="onExportTypeChange($event)" [layerSet]="'set-02'">
            </iui-select>

            <iui-select id="dataFormat-options" name="dataFormat" [label]="'Rx.DataFormat' | translate"
                [options]="dataFormatOptions" [getOptionName]="getOptionName" [compareWith]="compareWith"
                [ngModel]="selectedDataFormatOption" (ngModelChange)="onDataFormatChange($event)" [layerSet]="'set-02'">
            </iui-select>

            <iui-select id="fileType-options" name="fileType" [label]="'Rx.FileType' | translate"
                [options]="fileTypeOptions" [getOptionName]="getOptionName" [compareWith]="compareWith"
                [ngModel]="selectedFileTypeOption" (ngModelChange)="onFileTypeChange($event)" [layerSet]="'set-02'">
            </iui-select>

            <iui-select *ngIf="imageBgInExportModal" id="imageBg-options" name="ImageBackground"
                [label]="'ExportModal.Image-background' | translate" [options]="imageBgOptions"
                [getOptionName]="getBgOptionName" [compareWith]="compareBgWith" [getOptionStyle]="getBgOptionStyle"
                [ngModel]="selectedBgOption" (ngModelChange)="onBgChange($event)" [layerSet]="'set-02'">
                <span iui-prefix class="bg-color-swatch" [style.background-color]="selectedBgOption?.color"
                    [class.bg-color-swatch--hidden]="!selectedBgOption">
                </span>
            </iui-select>

            <iui-checkbox logChange [locationParentObject]="'OrthoExportModal'" *ngIf="!disablePatientDetailsBySWOpiont"
                [id]="'orthoExport-hidePatientName-checkbox'" [checked]="hidePatientName"
                [isDisabled]="hidePatientName === undefined"
                (changeEvent)="onHidePatientNameChanged($event.checked)">
                {{ 'Settings.HidePatientName' | translate }}
            </iui-checkbox>
        </form>
    </iui-modal-content>
    <iui-modal-footer>
        <ng-container ngProjectAs="[right-buttons]">
            <button iuiButton logClick [locationParentObject]="'OrthoExportModal'" id="orthoExport-cancel-btn"
                type="brand" emphasis="secondary" size="l" (click)="close()">
                {{ 'Rx.Cancel' | translate }}
            </button>
            <button iuiButton logClick [locationParentObject]="'OrthoExportModal'" id="btn-export"
                type="brand" emphasis="primary" size="l" (click)="export()" [disabled]="!canExport()">
                {{ 'Rx.Export' | translate }}
            </button>
        </ng-container>
    </iui-modal-footer>
} @else {
    <tlk-modal-header header>
        <span class="modal-title">{{ 'Rx.Export' | translate }}</span>
        <button logClick id="orthoCadExport-close-btn" type="button" class="close" (click)="close()" right-icon>
            <img src="assets/images/close.svg" width="32" height="32" alt="close" />
        </button>
    </tlk-modal-header>
    <tlk-modal-content content>
        <form class="form-horizontal">
            <tlk-select
                        id="exportType-options"
                        name="exportType"
                        [label]="'Rx.ExportType' | translate"
                        [options]="exportTypeOptions"
                        [getOptionName]="getOptionName"
                        [compareWith]="compareWith"
                        [ngModel]="selectedExportTypeOption"
                        (ngModelChange)="onExportTypeChange($event)">
                    </tlk-select>

                    <tlk-select
                        id="dataFormat-options"
                        name="dataFormat"
                        [label]="'Rx.DataFormat' | translate"
                        [options]="dataFormatOptions"
                        [getOptionName]="getOptionName"
                        [compareWith]="compareWith"
                        [ngModel]="selectedDataFormatOption"
                        (ngModelChange)="onDataFormatChange($event)">
                    </tlk-select>

                    <tlk-select
                        id="fileType-options"
                        name="fileType"
                        [label]="'Rx.FileType' | translate"
                        [options]="fileTypeOptions"
                        [getOptionName]="getOptionName"
                        [compareWith]="compareWith"
                        [ngModel]="selectedFileTypeOption"
                        (ngModelChange)="onFileTypeChange($event)">
                    </tlk-select>

                    <div *ngIf="imageBgInExportModal" class="bg-color-select-wrapper">
                        <span
                            class="bg-color-swatch"
                            [style.background-color]="selectedBgOption?.color"
                            [class.bg-color-swatch--visible]="!!selectedBgOption">
                        </span>
                        <tlk-select
                            id="imageBg-options"
                            name="ImageBackground"
                            class="bg-color-select"
                            [label]="'ExportModal.Image-background' | translate"
                            [options]="imageBgOptions"
                            [getOptionName]="getBgOptionName"
                            [compareWith]="compareBgWith"
                            [getOptionStyle]="getBgOptionStyle"
                            [ngModel]="selectedBgOption"
                            (ngModelChange)="onBgChange($event)">
                        </tlk-select>
                    </div>

            <div *ngIf="!disablePatientDetailsBySWOpiont">
                <tlk-checkbox [id]="'orthoExport-hidePatientName-checkbox'"
                    logChange
                    [checked]="hidePatientName"
                    [isDisabled]="hidePatientName === undefined"
                    (changeEvent)="onHidePatientNameChanged($event.checked)">
                    {{'Settings.HidePatientName' | translate }}
                </tlk-checkbox>
            </div>
        </form>
    </tlk-modal-content>
    <tlk-modal-footer footer>
        <ng-container ngProjectAs="[right-buttons]">
            <button logClick id="orthoCadExport-cancel-btn" type="button" class="btn btn-default orthoCadExport-btn" (click)="close()">
                {{'Rx.Cancel' | translate }}
            </button>

            <button logClick id="btn-export" type="button" class="btn btn-primary orthoCadExport-btn" (click)="export()" [disabled]="!canExport()">
                {{'Rx.Export' | translate }}
            </button>
        </ng-container>
    </tlk-modal-footer>
}
